module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/user/components/user-table/user-table.component.sass
// module id = ./src/app/modules/user/components/user-table/user-table.component.sass
// module chunks = main